import React from 'react'
import { useDispatch } from 'react-redux'
import _ from 'lodash'

import {
  TextField,
  Button,
  Typography,
  FormControl,
  FormHelperText,
  InputLabel,
  NativeSelect,
} from '@material-ui/core'

import { Formik, FormikProps } from 'formik'

import { ButtonGrid } from '../../components'
import { locale } from '../../locale'
import { createDevice } from '../../state/Firebase/operations'
import { createDeviceEnd } from '../../state/SystemCache/actions'
import { categories } from '../../utils'
import { Category } from '../../types'

const toj = JSON.stringify

type Props = {
  category: Category
}

export type Fields = {
  id: string
  category: Category
}

function CreateDeviceForm({ category }: Props) {
  const dispatch = useDispatch()
  const fields: Fields = {
    id: '',
    category,
  }

  return (
    <div>
      <Formik
        initialValues={fields}
        validate={(values) => {
          const errors: Partial<Fields> = {}

          if (!values.id) {
            errors.id = '必須です。'
          }
          if (!/^[A-Za-z0-9_]*$/.exec(values.id)) {
            errors.id = '使用できない文字が含まれています。'
          }
          return errors
        }}
        onSubmit={(values: Fields, { setErrors }) => {
          dispatch(createDevice(values, setErrors))
        }}
        render={({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          setFieldTouched,
        }: FormikProps<Fields>) => {
          const change = (name, e) => {
            e.persist()
            handleChange(e)
            setFieldTouched(name, true, false)
          }

          return (
            <form onSubmit={handleSubmit}>
              <Typography variant="h6">{locale.deviceEntity}の追加</Typography>
              <TextField
                id="id"
                name="id"
                error={touched.id && Boolean(errors.id)}
                autoComplete="off"
                label={`${locale.device.id} (半角英数字と\`_(アンダーバー)\`のみ使用できます)`}
                helperText={touched.id ? errors.id : ''}
                value={values.id}
                inputProps={{
                  pattern: '^[0-9A-Za-z]+$',
                }}
                onChange={change.bind(null, 'label')}
                fullWidth
                required
              />
              <Typography variant="caption" color="error">
                後からIDを変更することは出来ません。
              </Typography>
              <FormControl style={{ width: '100%' }}>
                <FormHelperText>
                  <InputLabel htmlFor="category">
                    {locale.device.category}
                  </InputLabel>

                  <NativeSelect
                    id="category"
                    name="category"
                    value={category}
                    disabled
                    onChange={change.bind(null, 'category')}
                  >
                    {_.map(categories, (label, id) => (
                      <option key={id} value={id}>
                        {label}
                      </option>
                    ))}
                  </NativeSelect>
                </FormHelperText>
              </FormControl>
              <Typography variant="caption" color="error">
                後から{locale.device.category}を変更することはできません。
              </Typography>
              <ButtonGrid>
                <Button onClick={() => dispatch(createDeviceEnd())}>
                  キャンセル
                </Button>
                <Button
                  color="primary"
                  disabled={!values.id || toj(fields) === toj(values)}
                  onClick={() => handleSubmit()}
                >
                  作成する
                </Button>
              </ButtonGrid>
            </form>
          )
        }}
      />
    </div>
  )
}

export default CreateDeviceForm
